import debounce from 'lodash-es/debounce'
import * as userTypes from '@vue-storefront/core/modules/user/store/mutation-types'

export async function afterRegistration ({ Vue, config, store, isServer }) {
  if (isServer) return

  const fetchCustomer = debounce(function () {
    store.dispatch('netsuite/fetchCustomer').catch(() => {})
  }, 10000, { leading: true, trailing: false })

  const fetchOrders = debounce(function () {
    store.dispatch('netsuite/fetchOrders', { onlyOpeningOrders: true }).catch(() => {})
  }, 10000, { leading: true, trailing: false })

  store.subscribe((mutation, state) => {
    const type = mutation.type

    // Load NetSuite customer (incl. brand manager) once Magento user is available
    if (type.endsWith(userTypes.USER_INFO_LOADED) && state.user && state.user.token) {
      // fetchCustomer()
    }

    // Clear NetSuite state on logout
    if (type.endsWith(userTypes.USER_END_SESSION)) {
      store.dispatch('netsuite/clear')
    }
  })

  // If the user is already logged in when the module registers, hydrate on demand
  if (store.getters['user/isLoggedIn'] && store.getters['user/getUserToken']) {
    // fetchCustomer()
    // fetchOrders()
  }




  // todo: retrieve only opening orders from netsuite for customer when viewing the order history
  // inject those into the order history component

  // on normal single orders that are sourced from magento, also fetch netsuite order details.
  // and inject those into the order details component
}
